





























































































































































































































































































































































































































































































































































































































import Vue from 'vue'
import { mapActions } from 'vuex'
import mixins from 'vue-typed-mixins'

import AuthorizationMixin from '@/routing/AuthorizationMixin'


// types
import { ReturnBookingFragment } from '@/graphql-schema'

// process
import Process from '@/components/workflow/Process.vue'
import Timer from '@/components/workflow/Timer.tsx'
import Task from '@/components/workflow/Task.tsx'
import Gateway from '@/components/workflow/Gateway.tsx'
import DatePicker from '@/components/workflow/Datepicker.vue'

// interview booking
import InterviewBooking from '@/views/interview-booking/BookInterview.vue'

// interview report
import Report from '@/components/interviews/Report.vue'
import Artifacts from '@/components/artifacts/Artifacts.tsx'


export interface ComponentData {
  phoneNumber: string
  diagnosis: string | null
  newDate: string | null
}

export default mixins(AuthorizationMixin).extend({
  components: {
    // report
    Artifacts,
    Report,
    // workflow
    DatePicker,
    Gateway,
    Process,
    Task,
    Timer,
    // interview
    InterviewBooking,
  },
  created() {
    this.phoneNumber = this.currentCase.me?.phone || null
  },
  computed: {
    currentCase(): any {
      return this.$store.getters.currentCase
    },
    asInterviewee(): ReturnBookingFragment[] {
      return (this.$store.getters[
        'interview/bookings/asInterviewee'
      ] as ReturnBookingFragment[]).filter(booking => !booking!.canceled && !booking!.offer!.post)
    },
    asInterviewer(): ReturnBookingFragment[] {
      return (this.$store.getters[
        'interview/bookings/asInterviewer'
      ] as ReturnBookingFragment[]).filter(booking => !booking!.canceled && !booking!.offer!.post)
    },
  },
  data(): ComponentData {
    return {
      phoneNumber: '',
      newDate: null,
      diagnosis: null,
    }
  },
  methods: {
    ...mapActions('interview', { fetchOffersAndBookings: 'fetch' }),
    getDiagnosis(report: {
      patient_accepted?: boolean
      patient_accepted_for_counseling?: boolean
      primary_problem_status_accepted?: string
    }): 'ptsd' | 'mde' | 'counseling' | 'excluded' | undefined {
      if (typeof report.patient_accepted === 'undefined') {
        return undefined
      } else if (!report.patient_accepted && !report.patient_accepted_for_counseling) {
        return 'excluded'
      } else if (report.primary_problem_status_accepted!.startsWith('PTSD Treatment')) {
        return 'ptsd'
      } else if (report.primary_problem_status_accepted!.startsWith('Depression Treatment')) {
        return 'mde'
      } else {
        return 'counseling'
      }
    },
    confirm(callback: () => any): any {
      if (
        window.confirm(
          (this.$t('interview.therapistConfirmsCancellation') as string) ||
            'You are cancelling a booked appointment. Do you want to proceed?'
        )
      ) {
        return callback()
      }
    },
  },
})
